import { render, staticRenderFns } from "./VATReportBEList.vue?vue&type=template&id=211ee5bf&"
import script from "./VATReportBEList.vue?vue&type=script&lang=js&"
export * from "./VATReportBEList.vue?vue&type=script&lang=js&"
import style0 from "./VATReportBEList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports